import React, { Fragment, useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import clsx from "clsx";
import proj4 from "proj4";

// Open layers
import WKT from "ol/format/WKT";
import OlFormatWKT from "ol/format/WKT";

//MUI Core Components

import Typography from "@mui/material/Typography";
import Collapse from "@mui/material/Collapse";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionActions from "@mui/material/AccordionActions";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";

//MUI Icons
import RouteIcon from "@mui/icons-material/Route";
import EditIcon from "@mui/icons-material/Edit";

//Custom Components
import MapCard from "@/ui/MapCard/MapCard";
import MapCardHeader from "@/ui/MapCard/MapCardHeader";
import MapCardAvatar from "@/ui/MapCard/MapCardAvatar";
import MapCardContent from "@/ui/MapCard/MapCardContent";
import MapCardActions from "@/ui/MapCard/MapCardActions";
import MapCardActionButton from "@/ui/MapCard/MapCardActionButton";
import dataController from "@/lib/dataController";
import MapCardHeaderButtonClose from "@/ui/MapCard/MapCardHeaderButtonClose";
import DialogContext from "@/ui/DialogContext/DialogContext";
import { GridContainer, GridItem } from "@/ui/Grid";

// import { dataService } from "@/services/dataService";
import FormContent from "@/components/FormContent";
import UserContext from "@/components/UserContext/UserContext";

import modelSegment from "@/models/segmenti";

import RoutingSegmentDialog from "./RoutingSegmentDialog";
// import InspectionDialog from "Views/MapPage/InspectionDialog";

//Types
import { GSInfoCardProps } from "@/@types/views/GIS/map";
import { Permissions } from "@/lib/permissions";

function RoutingSegmentInfoCard(props: GSInfoCardProps) {
  const { t } = useTranslation();

  const initialRecod = props.featureData.record
    ? props.featureData.record
    : props.featureData.feature.properties;

  const [record, setRecord] = useState(initialRecod);
  const dialogContext = useContext(DialogContext);

  const {
    featureData,
    onClose,
    updateCardOverlay,
    refreshLayers,
    commentRecords,
  } = props;


  const dc = new dataController(modelSegment);

  const faIconClass = "fas fa-info ";

  const handleEdit = () => {
    dialogContext.showDialog(RoutingSegmentDialog, {
      dc: dc,
      recordId: record.id,
      mode: "update",
      form: "update",
      iconClass: faIconClass,
      onClose: handleDataDialogClose,
      preClose: updateCardOverlay,
    });
  };

  const handleRedirect = (url: string) => {
    window.open(url);
  };

  const handleDataDialogClose = (dialogResult: {
    dataChanged: boolean;
    action: string;
  }) => {
    if (dialogResult.dataChanged) {
      if (refreshLayers) refreshLayers();
    }
  };


  useEffect(() => {
    if (featureData) {
      if (featureData.record) {
        setRecord(featureData.record);
      } else if (featureData.feature) {
        setRecord(featureData.feature.properties);
      }
    }
    setRecord;
  }, [featureData]);



  return (
    <Fragment>
      <MapCard
        sx={{
          backgroundColor: "background.default",
          minWidth: "200px",
        }}
      >
        <MapCardHeader
          title={t("titles.segment")}
          subheader={`${t("common.id")}: ${record.id}`}
          subheaderTypographyProps={{ color: "initial" }}
          avatar={<MapCardAvatar ariaLabel="info" icon={<RouteIcon/>} />}
          action={
            <MapCardHeaderButtonClose
              onClick={() => {
                onClose();
              }}
            />
          }
        />
        <MapCardContent>
          <GridContainer spacing={0}>
            <FormContent
              fields={dc.getFormFields("overlay")}
              fieldNames={dc.getFormFieldsNames("overlay")}
              columns={1}
              mode="simpleView"
              record={record}
            />
          </GridContainer>
        </MapCardContent>
        <MapCardActions>
          <MapCardActionButton
            startIcon={<EditIcon />}
            variant="contained"
            onClick={() => handleEdit()}
            needPermission={[Permissions.Administration]}
          >
            {t("buttons.edit")}
          </MapCardActionButton>
        </MapCardActions>
      </MapCard>
    </Fragment>
  );
}

export default RoutingSegmentInfoCard;
